module.exports = __webpack_public_path__ + "img/500.098c474b.png";